import { render } from "./workloadSkeleton.vue?vue&type=template&id=89043854"
import script from "./workloadSkeleton.vue?vue&type=script&lang=js"
export * from "./workloadSkeleton.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./workloadSkeleton.vue?vue&type=style&index=0&id=89043854&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__